/**
 * Regex para validar enlaces de videollamada (Meet, Zoom, Teams).
 * Acepta:
 *  - https://meet.google.com/xxx-xxxx-xxx
 *  - https://zoom.us/j/123 (y subdominios como us02web.zoom.us)
 *  - https://teams.microsoft.com/... y https://teams.live.com/...
 */
export const MEETING_LINK_REGEX =
  /^https:\/\/(meet\.google\.com\/[A-Za-z0-9\-_?=&]+|([a-z0-9-]+\.)?zoom\.us\/[A-Za-z0-9/\-_?=&.#%]+|teams\.(microsoft|live)\.com\/[A-Za-z0-9/\-_?=&.#%@:!]+)$/i;
